<template>
  <section
    v-if="isVisible"
    :id
    :class="{
      container: !parentType,
    }"
  >
    <ParagraphRemoteVideoModal
      v-if="options.isModal && previewMedia && remoteVideo"
      :id="uuid"
      :preview="previewMedia"
      :remote-video="remoteVideo"
    />
    <LazyMediaRemoteVideo
      v-else
      v-bind="remoteVideo"
      :class="{
        'pointer-events-none': isEditing,
      }"
    />
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphRemoteVideoFragment } from '#graphql-operations'

defineProps<ParagraphRemoteVideoFragment>()

const { options, uuid, parentType, rootBlocks, isEditing, index, siblings } =
  defineBlokkli({
    bundle: 'remote_video',
    globalOptions: [
      'isHero',
      'contextToggleId',
      'bkHiddenGlobally',
      'publicationChannels',
    ],
    options: {
      isModal: {
        type: 'checkbox',
        label: 'Open video in Modal',
        default: false,
      },
    },
  })

const { determineVisibility } = usePartyToggle()
const isVisible = determineVisibility(options, rootBlocks)
const id = useParagraphAnchorId(index, siblings)
</script>
